import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
// TODO: refactor this
// eslint-disable-next-line no-restricted-imports
import { useAsObservableSource } from 'mobx-react-lite';
import { MeetingsRow } from 'src/domains/sportsbook/webview/components/meetingsRow/MeetingsRow';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { MeetingsListState, RowType } from 'src/domains/sportsbook/webview/components/meetingsList/MeetingsList.state';
import {
    LoaderWrapperMeetings,
    MeetingsListInfo,
    MeetingsListStyle,
} from 'src/domains/sportsbook/webview/components/meetingsList/MeetingsList.style';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';
import { HorseRacingSelectedNew } from 'src/domains/sportsbook/webview/components/racing/NewRacingPage.state';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { StreamingState } from 'src/domains/sportsbook/state/streamingState/StreamingState';
import { BetGliderState } from 'src/domains/sportsbook/state/betGliderState/BetGliderState';
import { TableSportsRowHrEvent } from 'src/ui/components/table/sports/row/hr-gr/event/TableSportsRowHrEvent';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';

export interface MeetingsListPropsType {
    events: Array<EventModel> | null;
    isBuilding: boolean;
    selected: HorseRacingSelectedNew;
    isOpen?: boolean;
    isLoading: boolean;
    onChoose?: (eventId: EventId) => void;
}

export const MeetingsList = observer('MeetingsList', (propsIn: MeetingsListPropsType) => {
    const props = useAsObservableSource(propsIn);
    const [state] = useState(() => new MeetingsListState(props));

    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const streamingState = StreamingState.get(common);
    const betGliderState = BetGliderState.get(common);

    const isDarkUniverse = configState.isDarkUniverse;
    const isOpen = props.isOpen === undefined ? true : props.isOpen;

    const renderContent = (): JSX.Element | Array<JSX.Element | null> => {
        const { selected, isBuilding } = props;
        const breakpointsState = BreakpointsState.get(common);

        if (props.events === null || props.isLoading) {
            return (
                <MeetingsListInfo variant={configState.componentVariants.sportsbookVariant}>
                    <LoaderWrapperMeetings
                        size={14}
                        version={isDarkUniverse ? 'light' : 'dark'}
                    >
                        <I18n
                            langKey='events.meetings-list.loading'
                            defaultText='Loading races...'
                        />
                    </LoaderWrapperMeetings>
                </MeetingsListInfo>
            );
        }

        if (props.events.length === 0) {
            return (
                <MeetingsListInfo variant={configState.componentVariants.sportsbookVariant}>
                    <I18n
                        langKey='events.meetings-list.empty'
                        defaultText='There are no races available at the moment. Please check again later.'
                    />
                </MeetingsListInfo>
            );
        }

        const isMobile = breakpointsState.tablet.isBiggerOrEq === false;

        return state.totalEventsByRow.map((row: RowType) => {
            const competitionModel = row.competitionId.getModel();

            const hasStreaming =
                configState.hasEventLiveStreaming && row.events.some((event) => streamingState.hasStream(event.id));
            const showBetGliderLabel =
                configState.isBetGliderActive &&
                isMobile &&
                row.events.some((event) => {
                    return event.sport === 'horseracing' && betGliderState.isRaceMapped(event);
                });

            if (row.events.length === 0) {
                return null;
            }

            const competitionName = competitionModel?.name ?? null;
            const raceName = (competitionName ?? '').trim();

            return (
                <TableSportsRowHrEvent
                    key={row.competitionId.toOldId()}
                    label={raceName === '' ? '-' : raceName}
                    hasStream={hasStreaming}
                    showBetGliderLabel={showBetGliderLabel}
                >
                    <MeetingsRow
                        key={`${row.competitionId.toOldId()}-rowId`}
                        events={row.events.map((item) => item.id2)}
                        selected={selected}
                        isBuilding={isBuilding}
                        onChoose={props.onChoose}
                    />
                </TableSportsRowHrEvent>
            );
        });
    };

    return (
        <MeetingsListStyle
            isOpen={isOpen}
            variant={configState.componentVariants.sportsbookVariant}
        >
            {renderContent()}
        </MeetingsListStyle>
    );
});
